import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import './index.css';
import App from './containers/App/App';
import * as serviceWorker from './serviceWorker';
import { thunk } from 'redux-thunk';
import overviewReducer from './store/reducers/overview';
import screenshotReducer from './store/reducers/screenshotTool';

const composeEnhancers =
  (process.env.NODE_ENV === 'development' || process.env.REACT_APP_NODE_ENV === 'development')
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose;
    
const rootReducers = combineReducers({
    overview: overviewReducer,
    screenshot: screenshotReducer
});

const store = createStore(rootReducers, composeEnhancers(applyMiddleware(thunk)));

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

const rootElement = document.getElementById('root')
const root = createRoot(rootElement);
root.render(app)

serviceWorker.unregister();